<template>
  <div class="start-xs relative">
    <div class="sidebar" id="sidebar-desktop">
      <div class="filters bg-cl-white brdr-10px py10">
        <div class="pt5">
          <span
            class="filter-label flex middle-xs cl-light-gray relative pointer uppercase"
            @click="toggleNewFilter()"
            :class="{ active: isNewFilterActive }"
          >
            {{ $t('Everything new') }}
          </span>
        </div>
        <!-- <div v-if="!isMarketplace" class="pt5">
          <span
            class="filter-label flex middle-xs cl-light-gray relative pointer uppercase"
            @click="toggleSubscriptionFilter()"
            :class="{ active: isSubscriptionFilterActive }"
          >
            {{ $t('Available in subscription') }}
          </span>
        </div> -->
        <div v-if="!isMarketplace" class="pt5">
          <span
            class="filter-label flex middle-xs cl-light-gray relative pointer uppercase"
            @click="toggleShowroomFilter()"
            :class="{ active: isShowroomFilterActive }"
          >
            {{ $t('Available in showroom') }}
          </span>
        </div>
        <div class="pt5">
          <span
            class="filter-label flex middle-xs cl-light-gray relative pointer uppercase"
            @click="toggleVideoFilter()"
            :class="{ active: isVideoFilterActive }"
          >
            {{ $t('Product with video') }}
          </span>
        </div>
        <p
          v-if="getCurrentCategory.id !== 2 && children"
          class="pt20 my0 flex middle-xs pointer cl-light-gray uppercase relative small-space bold"
        >
          {{ $t('Category') }}
        </p>
        <div>
          <div
            v-for="singleCategory in children"
            :key="singleCategory.slug"
            class="py5"
          >
            <router-link
              class="filter-label flex middle-xs cl-light-gray relative pointer"
              :class="{ active: getCurrentCategory.id === singleCategory.id }"
              :to="localizedRoute({path: '/' + singleCategory.url_path, query: $route.query})"
            >
              {{ singleCategory.name }}
            </router-link>
          </div>
        </div>
        <div
          v-for="(filter, filterIndex) in availableFilters"
          :key="filterIndex"
          v-if="filterIndex !== 'price'"
        >
          <p class="pt20 my0 flex middle-xs pointer cl-light-gray uppercase relative small-space bold">
            {{ frontendLabel(filterIndex) }}
          </p>
          <div class="flex wrap scroll-box">
            <filter-selector
              context="category"
              class="block uppercase"
              :code="filterIndex"
              v-for="(option, index) in customFilters(filter, filterIndex)"
              :key="index + option.label"
              :variant="option"
              :selected-filters="getCurrentFilters"
              @change="$emit('changeFilter', $event)"
            />
          </div>
        </div>
      </div>
      <div class="bottom-nav env-padding-bottom" v-if="isMobileFitersOpen">
        <p class="close weight-200 my10 fs15 shadow-3" @click="closeFilters">
          {{ $t("Apply") }}<span class="pl5">({{ getCategoryProductsTotal }})</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterSelector from 'theme/components/core/FilterSelector'
import pickBy from 'lodash-es/pickBy'
import config from 'config'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import groupBy from 'lodash-es/groupBy'

export default {
  components: {
    FilterSelector
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getCurrentCategory: 'category-next/getCurrentCategory',
      getCategoryProductsTotal: 'category-next/getCategoryProductsTotal',
      getMenuCategories: 'category-next/getMenuCategories',
      isMobileFitersOpen: 'ui/isMobileFitersOpen'
    }),
    listByCode () {
      return this.$store.state.attribute.list_by_code
    },
    getCurrentFilters () {
      return this.$store.getters['category-next/getCurrentFilters']
    },
    children () {
      if (!config.entities.category.categoriesDynamicPrefetch && (this.getCurrentCategory.children_data && this.getCurrentCategory.children_data.length > 0 && this.getCurrentCategory.children_data[0].name)) { // we're using dynamic prefetching and getting just category.children_data.id from 1.7
        return this.getCurrentCategory.children_data
      } else {
        let foundCategory = this.getMenuCategories.find(c => {
          return c.id === this.getCurrentCategory.id
        })
        if (foundCategory && foundCategory.children_data) return foundCategory.children_data
      }
      return ''
    },
    availableFilters () {
      return pickBy(this.filters, (filter, filterType) => { return (filter.length && !this.$store.getters['category-next/getSystemFilterNames'].includes(filterType)) })
    },
    isSubscriptionFilterActive () {
      return this.$store.state.ui.isSubscriptionFilterActive
    },
    isShowroomFilterActive () {
      return this.$store.state.ui.isShowroomFilterActive
    },
    isVideoFilterActive () {
      return this.$store.state.ui.isVideoFilterActive
    },
    isNewFilterActive () {
      return this.$store.state.ui.isNewFilterActive
    },
    isMarketplace () {
      return this.$route.path.includes('/marketplace')
    }
  },
  methods: {
    customFilters (filter, filterIndex) {
      if (filterIndex === 'size' || filterIndex === 'dress_length' || filterIndex === 'maternity') {
        return this.sortSize(filter, filterIndex)
      } else {
        return filter
      }
    },
    sortSize (filters, filterIndex) {
      const rawFilterData = this.listByCode[filterIndex].options
      let extFilters = JSON.parse(JSON.stringify(filters))
      extFilters.map(option => {
        let record = rawFilterData.find(option1 => option1.value === option.id)
        if (record) option.sort_order = record.sort_order
        return option
      })
      return extFilters.sort((a, b) => { return a.sort_order - b.sort_order })
    },
    frontendLabel (filterIndex) {
      return this.listByCode[filterIndex] && this.listByCode[filterIndex].frontend_label
    },
    closeFilters () {
      this.$store.dispatch('ui/toogleMobileFilter', false)
      let body = document.getElementsByTagName('body')[0]
      body.classList.remove('iphone-scroll')
    },
    toggleNewFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleNewFilter').then(() => {
        if (!this.isNewFilterActive) {
          delete query.new
          delete query.sort
          this.$router.push({ query })
        } else {
          query.new = 'true'
          query.sort = 'id:desc'
          this.$router.push({ query })
        }
      })
    },
    toggleSubscriptionFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleSubscriptionFilter').then(() => {
        if (!this.isSubscriptionFilterActive) {
          delete query.subscription
          this.$router.push({ query })
        } else {
          query.subscription = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleShowroomFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleShowroomFilter').then(() => {
        if (!this.isShowroomFilterActive) {
          delete query.showroom
          this.$router.push({ query })
        } else {
          query.showroom = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleVideoFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleVideoFilter').then(() => {
        if (!this.isVideoFilterActive) {
          delete query.video
          this.$router.push({ query })
        } else {
          query.video = 'true'
          this.$router.push({ query })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$main: color(main);
$gray: color(gray);

.icon-postion {
  right: 0;
}
.scroll-box {
  @media (min-width: 992px) {
    overflow-x: hidden;
    max-height: 200px;
    overflow-y: auto;
  }
}
.sidebar {
  &.fixed {
    position: fixed;
    width: 290px;
    top: 130px !important;
    @media (max-width: 992px) {
      width: 24%;
    }
    @media (max-width: 1565px) {
      width: 18%;
    }
  }
  &.bottom-fixed {
    position: absolute;
    width: 300px;
    top: 1000px;
    @media (max-width: 992px) {
      width: 24%;
    }
    @media (max-width: 1565px) {
      width: 18%;
    }
  }
  &__header {
    display: flex;
    align-items: center;
  }

  &__inline-selecors {
    display: flex;
  }
  .bold {
    font-weight: bold;
  }
}
.filter-label {
  &:hover {
   &::before {
      background: $gray;
    }
    &:after {
     content: "";
      position: absolute;
      left: 5px;
      top: 7px;
      width: 2px;
      height: 5px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
      transform: rotate(45deg);
    }
  }
  &::before {
    content: "";
    position: relative;
    top: 0px;
    margin-right: 12px;
    min-width: 12px;
    min-height: 12px;
    border: 1px solid #CCCCCC;
  }
  &.active {
    &::before {
      background: $gray;
    }
    &:after {
      content: "";
      position: absolute;
      left: 5px;
      top: 7px;
      width: 2px;
      height: 5px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
      transform: rotate(45deg);
    }
  }
}
.bottom-nav {
  justify-content: center;
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  right: 15%;
  .close {
    width: 80%;
    border: 1px solid $main;
    background-color: $main;
    padding: 10px 0px;
    text-align: center;
    color: white;
    border-radius: 26px;
  }
}
.filters span, .filters p, .filters a {
  font-size: 0.9em;
}
::-webkit-scrollbar-thumb {
  background-color: #ccc;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #000;
}
</style>
